module.exports = __webpack_public_path__ + "img/space.1.0021eb78.webp";